import { FC } from "react";

import { MapLibreLassoShape } from "./maplibre-lasso-shape";
import { useMapLibreLassoSelect } from "./use-maplibre-lasso-select";

interface IMapLibreLassoSelectProps {
  isActive: boolean;
  /** The finished ring as `[lat, lng]` pairs — for a point-in-polygon test, not for keeping. */
  onComplete: (ring: [number, number][]) => void;
  onCancel: () => void;
}

/**
 * Draw a shape to select what is inside it — the MapLibre twin of the Leaflet-geoman polygon draw the
 * stations map used as a lasso.
 *
 * Gesture and drawing bundled together, for a screen that just wants the tool. The polygon editor pairs
 * the two itself, because its toolbar has to reach into the trace in progress.
 *
 * Renders only the shape in progress; nothing is left on the map once it closes.
 */
export const MapLibreLassoSelect: FC<IMapLibreLassoSelectProps> = ({
  isActive,
  onComplete,
  onCancel,
}) => {
  const { points, cursor } = useMapLibreLassoSelect({
    isActive,
    onComplete,
    onCancel,
  });

  if (!isActive) {
    return null;
  }

  return <MapLibreLassoShape points={points} cursor={cursor} />;
};
